// removed by extract-text-webpack-plugin
module.exports = {"medium":"_2-oPj","wrapper":"e74iI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItemMedia/RichUpdatesItemMedia.scss
// module id = ./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItemMedia/RichUpdatesItemMedia.scss
// module chunks = 5